import styled from "styled-components"

export const GoogleLocationWrap = styled.div`
 width: 98%;
`
